const tokenName = "token"

class AuthService {

    guardarToken(token: string) {
        console.log("guardando token");

        localStorage.setItem(tokenName, token)
    }

    getToken() {
        return localStorage.getItem(tokenName)
    }

    logout(){
        localStorage.removeItem(tokenName)
    }

}

export default new AuthService()